// extracted by mini-css-extract-plugin
export default {"main":"AboutUs_main__vHjd2","id":"AboutUs_id__bG0Fo","info":"AboutUs_info__XftsJ","title":"AboutUs_title__i7Act","image":"AboutUs_image__hlp5R","text":"AboutUs_text__GTnJc"};